import { useState } from "react";

const useMyAccountModal = () => {
  const [showEditNameModal, setShowEditNameModal] = useState<boolean>(false);
  const [showEditEmailModal, setShowEditEmailModal] = useState<boolean>(false);
  const [showEditPasswordModal, setShowEditPasswordModal] =
    useState<boolean>(false);
  const [showEditMemberModal, setShowEditMemberModal] =
    useState<boolean>(false);
  const [showEditDrawalMemberModal, setShowEditDrawalMemberModal] =
    useState<boolean>(false);

  return {
    showEditNameModal,
    showEditEmailModal,
    showEditPasswordModal,
    showEditMemberModal,
    showEditDrawalMemberModal,
    setShowEditNameModal,
    setShowEditEmailModal,
    setShowEditPasswordModal,
    setShowEditMemberModal,
    setShowEditDrawalMemberModal,
  };
};

export default useMyAccountModal;
